import { render, staticRenderFns } from "./DialogChangeTransferStatusCompany.vue?vue&type=template&id=2cdee1c8&"
import script from "./DialogChangeTransferStatusCompany.vue?vue&type=script&lang=js&"
export * from "./DialogChangeTransferStatusCompany.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeTransferStatusCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdee1c8')) {
      api.createRecord('2cdee1c8', component.options)
    } else {
      api.reload('2cdee1c8', component.options)
    }
    module.hot.accept("./DialogChangeTransferStatusCompany.vue?vue&type=template&id=2cdee1c8&", function () {
      api.rerender('2cdee1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChangeTransferStatusCompany.vue"
export default component.exports